﻿import Constant from 'utils/constants';

export const isCompleted = ({state}) => state === Constant.task.state.completed;
export const isActive = ({state}) => state !== Constant.task.state.completed;

export const hasCompletedTasks = (tasks) => tasks.some((task) => isCompleted(task));
export const hasActiveTasks = (tasks) => tasks.some((task) => isActive(task));

export const isPublishTreatmentPlan = ({action}) => action === Constant.task.action.publishTreatmentPlan;
